import { axiosWithAuth } from "helpers";
import { sourceFilesService } from "services";

export const importedSourceFilesService = {
	getSourceFiles: sourceFilesService.getSourceFiles,
	deleteSourceFile,
	editSourceFile: sourceFilesService.editSourceFile,
	importSourceFiles: sourceFilesService.importSourceFiles,
	getConflicts,
};

const RESIDUALS_API_URL = process.env.REACT_APP_API_URL_RESIDUALS;

function deleteSourceFile(id) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${RESIDUALS_API_URL}/api/source_files/${id}/imported_records`,
	});
}

function getConflicts({ id, type }) {
	return axiosWithAuth({
		method: "GET",
		params: { type },
		url: `${RESIDUALS_API_URL}/api/source_files/${id}/conflicts`,
	});
}
